module.exports = __webpack_public_path__ + "img/logo.dd9fcd52.png";